
import React from 'react';
import { ServiceData } from '@/types/serviceTypes';

interface ServiceProcessProps {
  service: ServiceData;
}

const ServiceProcess = ({ service }: ServiceProcessProps) => {
  if (!service.process) return null;
  
  return (
    <div className="mb-16">
      <h3 className="text-2xl font-serif font-bold mb-8 text-pkstone-900">
        Our Process
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {service.process.map((step, index) => (
          <div key={index} className="bg-pkgreen-50 p-6 rounded-lg border border-pkgreen-100 relative">
            <div className="absolute -top-4 -left-4 w-8 h-8 rounded-full bg-pkgreen-600 text-white flex items-center justify-center font-bold">
              {index + 1}
            </div>
            <h4 className="text-xl font-bold mb-3 text-pkstone-900 mt-2">
              {step.title}
            </h4>
            <p className="text-pkstone-700">
              {step.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceProcess;
